<div class="expandable-container" [attr.headless]="type" [attr.invalid]="state"
  [style]="'border-radius: '+ borderRadius +';box-shadow: '+ boxshadow +';'" [class.exp-cont-filter]="isFilters">
  <div class="expandable-header" *ngIf="type != 'headless'" [class.padd-24]="!icono && isFilters==false"
    [style]="'padding:'+ paddingCollapse +';'" [class.isexpanded]="expanded" (click)="toggleExpand()">
    <div class="title-coll {{typeicon}} ">
      <div class="icon" *ngIf="icono">
        <img [src]="icono" alt="" *ngIf="img" style="width: 1.5rem;">
        <fa-icon [icon]="icono" *ngIf="!img" class="cursor-pointer"></fa-icon>
      </div>
      <h3 [style]="titleStyle">{{ title }}</h3>
    </div>
    <div class="flex-cont">
      <div class="info-collapse" *ngIf="type == 'balance'">
        <p>${{balance}}</p>
      </div>
      <fa-icon [icon]="faChevronCircleDown" [class.open]="expanded" class="toggle-icon cursor-pointer"></fa-icon>
    </div>
  </div>
  <div class="expandable-content" [@expandAnimation]="expanded ? 'expanded' : 'collapsed'">
    <!-- <div style="padding: 0.75rem;"> -->
    <ng-content></ng-content>
    <!-- </div> -->
    <div class="footer-expandable" [class.isexpanded]="expanded" (click)="toggleExpand()"
      *ngIf="!isFilters && showLess==true">
      VER MENOS
    </div>
  </div>

  <div class="footer-expandable" [class.isexpanded]="expanded" (click)="toggleExpand()" *ngIf="type == 'headless'">
    {{!expanded ? 'VER DETALLE' : 'VER MENOS'}}
  </div>
</div>